import './privacy-policy.scss';

export const PRIVACY_POLICY_URL = 'https://www.knowmeq.com/privacy';

const PrivacyPolicy = () =>
  <span className={'privacy-policy'} onClick={() => window.open(PRIVACY_POLICY_URL)}>
  Privacy Policy
</span>

export default PrivacyPolicy;